/* eslint-disable react/display-name */
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import FilterListIcon from '@mui/icons-material/FilterList'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import InsertLinkIcon from '@mui/icons-material/InsertLink'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined'
import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined'
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined'
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import CloseIcon from '@mui/icons-material/Close'
import EmailIcon from '@mui/icons-material/Email'
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm'
import JoinLeftIcon from '@mui/icons-material/JoinLeft'
import JoinInnerIcon from '@mui/icons-material/JoinInner'
import JoinFullIcon from '@mui/icons-material/JoinFull'
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined'
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import FolderCopyIcon from '@mui/icons-material/FolderCopy'

const rendered =
    (Component: typeof SvgIcon) =>
    (props?: SvgIconProps): JSX.Element =>
        <Component {...props} />

const icons = {
    filter: { render: rendered(FilterListIcon) },
    arrowCircleRight: { render: rendered(ArrowCircleRightIcon) },
    arrowBack: { render: rendered(ArrowBackIcon) },
    bookmarkBorder: { render: rendered(BookmarkBorderIcon) },
    accessTime: { render: rendered(AccessTimeIcon) },
    eye: { render: rendered(VisibilityIcon) },
    closedEye: { render: rendered(VisibilityOffIcon) },
    expandMore: { render: rendered(ExpandMoreIcon) },
    expandLess: { render: rendered(ExpandLessIcon) },
    lockOutlined: { render: rendered(LockOutlinedIcon) },
    link: { render: rendered(InsertLinkIcon) },
    taskAliIcon: { render: rendered(TaskAltIcon) },
    infoOutlined: { render: rendered(InfoOutlinedIcon) },
    descriptionOutlined: { render: rendered(DescriptionOutlinedIcon) },
    videoOutlined: { render: rendered(PlayCircleOutlinedIcon) },
    ballot: { render: rendered(BallotOutlinedIcon) },
    library: { render: rendered(LibraryBooksOutlinedIcon) },
    handyman: { render: rendered(HandymanOutlinedIcon) },
    helpOutline: { render: rendered(HelpOutlineOutlinedIcon) },
    rightArrow: { render: rendered(ChevronRightIcon) },
    close: { render: rendered(CloseIcon) },
    mail: { render: rendered(EmailIcon) },
    time: { render: rendered(AccessAlarmIcon) },
    intermediate: { render: rendered(JoinLeftIcon) },
    beginner: { render: rendered(JoinInnerIcon) },
    advanced: { render: rendered(JoinFullIcon) },
    timerOutlined: { render: rendered(TimerOutlinedIcon) },
    language: { render: rendered(TranslateOutlinedIcon) },
    medal: { render: rendered(WorkspacePremiumIcon) },
    folders: { render: rendered(FolderCopyIcon) },
}

export type IconName = keyof typeof icons

export default icons
